webpackJsonp([39067504618698],{

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SPBImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPBLocation = function (_React$Component) {
	  _inherits(SPBLocation, _React$Component);
	
	  function SPBLocation() {
	    _classCallCheck(this, SPBLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SPBLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'St. Pete Beach, FL' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting ridership',
	        title: 'See the World on Two Wheels',
	        story: 'The annual National Bicycle Tourism Conference, sponsored by PeopleForBikes, brings together event promoters, tourism business owners, and city/government people involved in bike tourism and recreational bike events. PeopleForBikes gave a 30-minute presentation about our organization\u2019s priorities and talked about the PlacesForBikes and our new Bicycle Network Analysis (BNA) tool. The BNA garnered a great deal of interest from a diverse set of stakeholders, from touring operators to the Active Transportation Alliance. From our perspective, bike tourism inspires people to bike, encourages all types of riding and provides major economic benefits to communities across the nation.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'StPeteBeach',
	        alt: 'National Bicycle Tourism Conference',
	        sizes: this.props.data.spbImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Arlington, VA',
	        prevLocationPath: 'arlington',
	        prevLocationImgPath: this.props.data.spbPrevImage,
	        nextLocationName: 'Wichita',
	        nextLocationPath: 'wichita',
	        nextLocationImgPath: this.props.data.spbNextImage
	      })
	    );
	  };
	
	  return SPBLocation;
	}(_react2.default.Component);
	
	exports.default = SPBLocation;
	
	// GraphQL query
	
	var SPBImageQuery = exports.SPBImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-st-pete-beach-js-2dabfdd0c66c209f19ac.js